<ctx-page-template mode="table">
	<header tuiHeader class="nocurve">
		<div tuiHeaderMain>
			@if (backFolderId(); as backId) {
				<a
					tuiIconButton
					appearance="ghost"
					size="m"
					[routerLink]="nav.folderLink(backId)"
				>
					<tui-icon icon="@tui.arrow-left" />
				</a>
			}

			<div tuiHeaderInformation>
				@if (breadcrumbs().length) {
					<ctx-breadcrumbs
						[content]="folder()!"
						[segments]="breadcrumbs()"
						[showHome]="false"
						[linkFor]="breadcrumbLink"
					/>
				}

				<h2 class="m-0 overflow-ellipsis" tuiTitle>
					{{ folder()!.name }}
				</h2>
			</div>
		</div>
	</header>

	<ctx-table
		[placeholder]="placeholder"
		[empty]="isEmpty()"
		[loading]="loading()"
		[pagination]="true"
		[index]="tableIndex()"
		[length]="tableLength()"
		[details]="tableDetails()"
		[size]="tableSize()"
		(indexChange)="onPageChange($event)"
		(sizeChange)="onSizeChange($event)"
	>
		@for (item of tableItems(); track item.id) {
			<ctx-content-row
				tabindex="0"
				role="link"
				[content]="item.data"
				[showAccess]="false"
				[routerLink]="nav.contentLink(item.data)"
			/>
		}
	</ctx-table>
</ctx-page-template>
